import { render } from "./company.vue?vue&type=template&id=75071957&scoped=true&lang=pug"
import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"

import "./company.vue?vue&type=style&index=0&id=75071957&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75071957"]])

export default __exports__